<div
        class="ui-g-12 ui-lg-12 text-right"
        style="float:unset;">
    <button pButton type="button"
            class="k-generic-btn"
            icon="fa fa-angle-left"
            iconPos="left"
            (click)="customButton($event)"
            label="{{ 'common.back' | translate }}"></button>
</div>

<app-kontable
    id="dt_roles_users"
    [title] = "'roleMS.listUsersTitle' | translate"
    [columns] = "['id', 'user_name', 'user_surname', 'user_login']"
    [titles] = "['common.id', 'userForm.name', 'userForm.surname', 'userForm.login']"
    [source] = "roleUsers"
    [paginationType]="paginationType"
    [showGlobalFilter]="false"
    [showDetailsButton]="false"
    [showInfoButton]="false"
    [showAddButton]="true"
    [showEditButton]="false"
    [(fireNewDataAvailable)]="newDataAvailable"
    (onAdd)="editUserRole(null)"
    (onRemove)="remove($event)">
</app-kontable>

<p-dialog
        *ngIf="showDetail"
        [width]="600"
        header="{{modalTitle}}"
        [(visible)]="showDetail"
        [responsive]="true"
        [draggable]="false"
        [resizable]="false"
        showEffect="fade"
        (onHide)="closeDialogDetail()"
        [modal]="true">
    <app-rolesapplicationuser-form
            [roleUser]="selectedUserRoleMS"
            [role]="role"
            (onSave)="save($event)"
    ></app-rolesapplicationuser-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/rolesApplication/rolesApplicationUsers.component.html